const Storage = window.localStorage;
const StorageUtils = {
  __toJson(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  },
  __toString(json) {
    if (typeof json === 'string') {
      return json;
    }
    try {
      return JSON.stringify(json);
    } catch (e) {
      return json;
    }
  },
  get(name) {
    return this.__toJson(Storage.getItem(name));
  },
  set(name, value) {
    Storage.setItem(name, this.__toString(value));
  },
  del(name) {
    Storage.removeItem(name);
  },
  clear() {
    Storage.clear();
  }
};

export default StorageUtils;
